import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase.js"

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader,
  Alert,
} from "reactstrap";

import { UserAuth } from "contexts/AuthContext";

import { Link, useNavigate } from "react-router-dom";

function AdminNavbar(props) {
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");

  const [error, setError] = useState('')
  const [loading, setLoading]= useState(false)
  const { signout, currentUser, userDoc, setUserDoc } = UserAuth()

  const navigate = useNavigate();
  
  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });

  useEffect(() => {
    getUserDocs()
  }, [!currentUser])

  // Use the effect to detect changes in userDoc and reload the component
  useEffect(() => {
    // Any logic you want to execute when userDoc changes
    // For example, updating some state or performing specific actions
    getUserDocs()
    // For this example, I'm just console.logging the userDoc whenever it changes
    console.log("userDoc changed:", userDoc);
  }, [!userDoc]); // Add userDoc as a dependency
  
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };
  // this function is to open the Search modal
  const toggleModalSearch = () => {
    setmodalSearch(!modalSearch);
  };


  const logout = async (e) => {
    e.preventDefault()

    setLoading(true); 
    
    // register try
    try {
        setError('')
        setLoading(true)
        await signout()
        navigate('/sign-in')
    } catch (error) {
        setError('Failed to logout in.')
        console.log(error)
    }

    setLoading(false)
  }

  const getUserDocs = async () => {
  if (currentUser) {
    try {
      const userDocRef = doc(db, 'user', currentUser.uid);
      const docSnapshot = await getDoc(userDocRef);

      if (docSnapshot.exists()) {
        setUserDoc(docSnapshot.data());
      }
    } catch (error) {
      console.error(error.message);
    }
  }
  }

  return (
    <>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand>
              {props.brandText}
            </NavbarBrand>
          </div>
          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    {!userDoc ? 
                    <>
                      <img alt="..." src={require("assets/img/anime3.png")} />
                    </> 
                    : 
                    <>
                      <img alt="..." src={userDoc.user_image} />
                    </>
                    }
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                {error && <Alert color="danger">{error}</Alert>}
                  <NavLink tag="li">
                    <Link to="/admin/user-profile">
                    <DropdownItem className="nav-item">Profile</DropdownItem>
                    </Link>
                  </NavLink>
                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item" onClick={logout}>Sign Out</DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <ModalHeader>
          <Input placeholder="SEARCH" type="text" />
          <button
            aria-label="Close"
            className="close"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>
    </>
  );
}

export default AdminNavbar;
